import ReportService from '@/service/report.service'
import { router } from '@/router'
import axios from 'axios'

export default {
	state: {
		isTest: false,
		reports: '',
		reportsCount: '',
		report: '',
		allDzo: '',
		startData: '',
	},

	getters: {
		REPORT(state) {
			return state.report
		},
		reports(state) {
			return state.reports
		},
		REPORTS(state) {
			return state.reports
		},
		reportsCount (state) {
			return state.reportsCount
		},
		ALLDZO(state) {
			return state.allDzo
		},
		GETSTARTDATA(state) {
			return state.startData
		},
	},

	mutations: {
		set_start_data_for_create(state, startData) {
			state.startData = startData
		},

		setReport(state, report) {
			state.report = report
		},

		setAllResponse(state, reports) {
			state.reports = reports
		},

		setReports (state, payload) {
			state.reports = payload
		},

		setReportsCount (state, payload) {
			state.reportsCount = payload
		},

		set_all_dzo(state, allDzo) {
			state.allDzo = allDzo
		},

		test(state) {
			state.isTest = true
		},
	},
	actions: {
		getStartDataForCreateReport({ commit }) {
			return ReportService.getStartDataForCreateReport()
				.then(response => {
					commit('set_start_data_for_create', response.data)
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},

		getPreviousContract({ commit }) {
			return ReportService.getPreviousContract()
				.then(response => {
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},

		createReport({ commit, dispatch }, formData) {
			return ReportService.createReport(formData)
				.then(response => {
					router.push('/create-report/' + response.data.report_id + '/place')
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},

		createNewContract({ commit }, formData) {
			return ReportService.createNewContract(formData)
				.then(response => {
					location.reload()
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},

		deleteContract({ commit }, contractId) {
			return ReportService.deleteContract(contractId)
				.then(response => {
					location.reload()
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},

		stopContract({ commit }, contractId) {
			return ReportService.stopContract(contractId)
				.then(response => {
					location.reload()
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},

		createMetalPlace({ commit }, formData) {
			return ReportService.createMetalPlace(formData, formData.report_id).then(
				response => {
					router.push('/view-report/' + response.data.report_id)
				}
			)
		},
		updateMetalPlace({ commit }, formData) {
			return ReportService.updateMetalPlace(formData, formData.report_id).then(
				response => {
					router.push('/view-report/' + response.data.report_id)
				}
			)
		},
		test({ commit }, number) {
			return ReportService.createTest(number)
				.then(response => {
					commit('test')
					console.log(response)
				})
				.catch(error => {
					console.log(error)
				})
		},
		getHistory({ commit }, id) {
			return ReportService.getHistory(id)
				.then(response => {
					commit('test')
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},
		getReport({ commit }, id) {
			return ReportService.getReport(id).then(response => {
				commit('setReport', response.data.report)
				return response.data.report
			})
		},
		getCommonReportData({ commit }, id) {
			return ReportService.getCommonReportData(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},

		getMetalPlace({ commit }, id) {
			return ReportService.getMetalPlace(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},
		canBeSignedReport({ commit }, id) {
			return ReportService.canBeSignedReport(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},

		getPlaceStartData({ commit }, reportId) {
			return ReportService.getPlaceStartData(reportId)
				.then(response => {
					return response.data
				})
				.catch(error => {})
		},
		getInitialData({ commit }, reportId) {
			return ReportService.getInitialData(reportId)
				.then(response => {
					return response.data
				})
				.catch(error => {
					if (error.response.status === 403) {
						router.push({ name: 'notFound' })
					}
				})
		},
		isForceEdit({ commit }, reportId) {
			return ReportService.isForceEdit(reportId)
				.then(response => {
					return response.data
				})
				.catch(error => {})
		},
		getInitCategories({ commit }, id) {
			return ReportService.getInitCategories(id)
				.then(response => {
					commit('test')
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},
		getListSignXml({ commit }, id) {
			return ReportService.getListSignXml(id)
				.then(response => {
					commit('test')
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},
		sendFile({ commit }, formData) {
			return ReportService.sendFile(formData)
				.then(() => {
					commit('test')
					router.push({ name: 'reports' })
				})
				.catch(error => {
					console.log(error)
				})
		},
		importExcel({ commit }, formData) {
			return ReportService.importExcel(formData)
				.then(response => {
					commit('test')
					router.push({
						name: 'create-report-place',
						params: { id: response.data.report_id },
					})
				})
				.catch(error => {
					alert(error.response.data)
					location.reload()
				})
		},
		downLoadExcel({ commit }, formData) {
			return ReportService.downLoadExcel(formData)
				.then(response => {
					const url = URL.createObjectURL(
						new Blob([response.data], {
							type: 'application/vnd.ms-excel',
						})
					)
					const link = document.createElement('a')
					link.href = url
					let name = ''
					console.log(formData)
					if (formData.reportId) {
						name = formData.reportId
					}
					if (formData.month) {
						name = formData.month
					}
					link.setAttribute('download', 'Отчет_' + name + '.xlsx')
					document.body.appendChild(link)
					link.click()
					commit('test')
				})
				.catch(error => {
					console.log(error)
				})
		},
		rmReport({ commit, dispatch }, formData) {
			return ReportService.rmReport(formData)
				.then(response => {
					router.push({ name: 'my-reports' })
					dispatch('addNotification', {
						type: 'success',
						message: 'Удаление прошло успешно',
					})
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},
		updateReport({ commit, dispatch }, formData) {
			return ReportService.updateReport(formData)
				.then(response => {
					router.push({
						name: 'edit-report-place',
						params: { id: response.data.reportId },
					})
				})
				.catch(error => {
					if (error.response.status === 500) {
						dispatch('addNotification', {
							type: 'error',
							message:
								'статок на складе на конец месяца кол-во/сумма меньше нуля',
						})
					} else {
						dispatch('addNotification', {
							type: 'error',
							message: error.response.data,
						})
					}
				})
		},
		justUpdateReport({ commit, dispatch }, formData) {
			return ReportService.justUpdateReport(formData)
				.then(response => {
					router.push({
						name: 'edit-report-place',
						params: { id: response.data.reportId },
					})
				})
				.catch(error => {
					if (error.response.status === 500) {
						dispatch('addNotification', {
							type: 'error',
							message:
								'статок на складе на конец месяца кол-во/сумма меньше нуля',
						})
					} else {
						dispatch('addNotification', {
							type: 'error',
							message: error.response.data,
						})
					}
				})
		},
		getAllReports({ commit, dispatch }, page) {

			let payload = {
				page: page,
			}

			return axios
				.get('report/all-report/', {
					params: payload
				})
				.then(response => {
					commit('setReports', response.data.results)
					commit('setReportsCount', response.data.count)
					return response.data
				})
				.catch(error => {
					if (error.response.data.detail === 'Signature has expired.') {
						dispatch('logout')
					}
				})
		},

		deleteAllReport({ commit, dispatch }) {
			return ReportService.deleteAllReport()
				.then(() => {
					commit('test')
					location.reload()
				})
				.catch(error => {
					if (error.response.data.detail === 'Signature has expired.') {
						dispatch('logout')
					}
				})
		},

		getAllReportsNotMe({ commit, dispatch }) {
			return ReportService.getAllReportsNotMe()
				.then(response => {
					commit('setAllResponse', response.data)
					return response.data
				})
				.catch(error => {
					if (error.response.data.detail === 'Signature has expired.') {
						dispatch('logout')
					}
				})
		},

		getAllReportsFinish({ commit, dispatch }) {
			return ReportService.getAllReportsFinish()
				.then(response => {
					commit('setAllResponse', response.data)
				})
				.catch(error => {
					if (error.response.data.detail === 'Signature has expired.') {
						dispatch('logout')
					}
				})
		},
		sendSignXml({ commit }, formData) {
			return ReportService.sendSignXml(formData)
		},
		sendSignXmls({ commit }, formData) {
			return ReportService.sendSignXmls(formData)
		},
		approvedKmg({ commit }, formData) {
			return ReportService.approvedKmg(formData)
				.then(() => {
					commit('test')
					location.reload()
				})
				.catch(() => {})
		},

		rejectReport({ commit }, formData) {
			return ReportService.rejectReport(formData)
				.then(response => {
					commit('test')
					router.push({ name: 'reports' })
				})
				.catch(error => {
					console.log(error)
				})
		},

		rejectReportMetall({ commit }, formData) {
			return axios
				.get(`report/reject_after_edit/${formData.reportId}/`)
				.then(response => {
					commit('test')
					router.push({ name: 'reports' })
				})
				.catch(error => {
					console.log(error)
				})
		},

		rejectReportDzo({ commit }, formData) {
			return ReportService.rejectReportDzo(formData)
				.then(response => {
					commit('test')
					router.push({ name: 'reports' })
				})
				.catch(error => {
					console.log(error)
				})
		},

		getAllDzo({ commit }) {
			return ReportService.getAllDzo()
				.then(response => {
					commit('set_all_dzo', response.data)
				})
				.catch(error => {
					console.log(error)
				})
		},

		getBlackCatalog({ commit }) {
			return ReportService.getBlackCatalog()
				.then(response => {
					commit('test')
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},

		getColorCatalog({ commit }) {
			return ReportService.getColorCatalog()
				.then(response => {
					commit('test')
					return response.data
				})
				.catch(error => {
					console.log(error)
				})
		},

		downloadFile({ commit }, file_url) {
			return ReportService.downloadFile(file_url).then(response => {
				commit('test')
				let blob = new Blob([response.data], { type: 'application/pdf' }),
					url = window.URL.createObjectURL(blob)
				// var fileLink = document.createElement('a');
				// fileLink.href = file_url;
				// fileLink.setAttribute('download', file_url);
				// document.body.appendChild(fileLink);
				// fileLink.click();

				window.open(url)

				// var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				// var fileLink = document.createElement('a');
				//
				// fileLink.href = fileURL;
				// fileLink.setAttribute('download', 'file.pdf');
				// document.body.appendChild(fileLink);
				//
				// fileLink.click();
			})
		},
	},
}
